import { render, staticRenderFns } from "./StageRuleSection.vue?vue&type=template&id=fd8b4874&"
import script from "./StageRuleSection.vue?vue&type=script&lang=js&"
export * from "./StageRuleSection.vue?vue&type=script&lang=js&"
import style0 from "./StageRuleSection.vue?vue&type=style&index=0&id=fd8b4874&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports